export var ECompareType;

(function (ECompareType) {
  ECompareType["Eq"] = "eq";
  ECompareType["InList"] = "inList";
})(ECompareType || (ECompareType = {}));